const API = process.env.REACT_APP_API_URL || '';
const BASE = `${API}/api/agent`;

async function parse(res) {
  try { return await res.json(); } catch { return { success: false, message: 'No answer from the server' }; }
}
export async function api(path, { method = 'GET', body } = {}) {
  const res = await fetch(`${BASE}${path}`, { method, credentials: 'include', headers: body ? { 'Content-Type': 'application/json' } : undefined, body: body ? JSON.stringify(body) : undefined });
  return parse(res);
}

export function fmtWhen(d) { return d ? new Date(d).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : ''; }
